import React from 'react';
import Attachment from '../../../../../components/NewAttachment/NewAttachment';
import AdditionalContent from './AdditionalContent';
import Actions from './Actions';
import styles from './Documents.module.scss';

const DocsList = ({
  items,
  getAttachmentUrl,
  allDocs,
  onDeleteDocument,
  onEditClick,
  showAdditionalContent = true,
  showActions = true,
  attachmentClassName,
  columnAmount,
}) => {
  return (
    <ul className={styles.docsList}>
      {items.map((attachment) => (
        <li key={attachment.id}>
          <Attachment
            className={attachmentClassName}
            attachments={allDocs}
            attachment={attachment}
            getAttachmentUrl={getAttachmentUrl}
            onDeleteAttachment={onDeleteDocument}
            renderAdditionalContent={
              showAdditionalContent
                ? ({ attachment }) => (
                    <AdditionalContent attachment={attachment} />
                  )
                : undefined
            }
            renderActions={
              showActions
                ? ({ attachment }) => (
                    <Actions
                      attachment={attachment}
                      onEditClick={onEditClick}
                    />
                  )
                : undefined
            }
            columnAmount={columnAmount}
          />
        </li>
      ))}
    </ul>
  );
};

export default DocsList;
